import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Notification } from 'src/app/modules/notifications/store/notifications.models';
import * as fromNotifications from '../../store/index';
import { QueryParams } from '@app/modules/core/store/models';
import { selectCurrentUrl } from '@app/modules/core/store/routing';
import { map } from 'rxjs/operators';

@Component({
    selector: 'topo-notification-sidebar',
    templateUrl: './notification-sidebar.component.html',
    styleUrls: ['./notification-sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NotificationSidebarComponent implements OnInit {
  showNotifications$: Observable<boolean>;
  notifications$: Observable<Notification[]>;
  params$: Observable<QueryParams>;
  isOnMap$: Observable<boolean>;

  constructor(private store$: Store<any>) {}

  ngOnInit(): void {
    this.showNotifications$ = this.store$.select(fromNotifications.selectShowNotifications);
    this.notifications$ = this.store$.select(fromNotifications.selectUnreadNotifications);
    this.params$ = this.store$.select(fromNotifications.selectUnreadQueryParams);
    this.isOnMap$ = this.store$.select(selectCurrentUrl).pipe(map(currentUrl => (!!currentUrl ? currentUrl?.includes('/cop') : false)));
  }

  closeNotificationsClick(): void {
    this.store$.dispatch(fromNotifications.hideNotifications());
  }

  clearAllNotificationsClick(): void {
    this.store$.dispatch(fromNotifications.clearAllNotifications({ clearPermanent: true }));
  }
}
